module.exports = __webpack_public_path__ + "static/media/task_assign_two.5bf4a1f3.png";